module.exports = __webpack_public_path__ + "img/Da.62bb4b0b.png";